'use strict';

const React = require('react');
const Relay = require('react-relay/classic');
const PropTypes = require('prop-types');
const GridBase = require('./GridBase');
const GridHeader = require('./GridHeader');
const { GridItemRelayContainer } = require('./GridItem');

const get = require('lodash.get');

class GridSuggestion extends GridBase {
    constructor(props) {
        super(props);

        this.state = {
            quickViewItemId: null,
            loadLazyImages: false,
        };

        this.items = null;
        this._setQuickViewId = this._setQuickViewId.bind(this);
    }

    _getHeader() {
        return (
            <div className="pdp-suggestion-grid-header">
                <GridHeader title={this.props.copy.suggestion.carouselHeader} />
            </div>
        );
    }

    _getItems() {
        const {
            userId,
            userIds,
            viewer,
            selectedItemIds,
            gridType,
            loadPortfolioData,
            shouldFillInFolder,
            onFavorited,
            onAddItemSuccess,
            currency,
        } = this.props;

        const pdpFolderItemRelayVariables = {
            loadPortfolioData,
            userId,
            userIds,
            selectedItemIds,
            shouldFillInFolder,
        };

        const itemsObj = {};
        if (get(viewer, 'items.edges.length')) {
            viewer.items.edges.forEach(edge => {
                const item = edge.node;
                if (item && item.serviceId) {
                    Object.assign(itemsObj, {
                        [item.serviceId]: item,
                    });
                }
            });
        }

        return this.props.data.map((data, index) => {
            // index needs to be 1-based, not 0-based
            data.index = index + 1;
            return (
                <div className="pdp-grid-item colLg3 colMd6 colXs6" key={data.id}>
                    <GridItemRelayContainer
                        itemId={data.id}
                        viewer={viewer}
                        item={itemsObj[data.id] || null}
                        setQuickViewId={this._setQuickViewId}
                        quickViewItemId={this.state.quickViewItemId}
                        gridType={gridType}
                        onFavorited={onFavorited}
                        onAddItemSuccess={onAddItemSuccess}
                        itemTitleTag="h3"
                        loadLazyImages={this.state.loadLazyImages}
                        cancelLazyLoad={() => this.cancelLazyLoad()}
                        currency={currency}
                        {...data}
                        {...pdpFolderItemRelayVariables}
                    />
                </div>
            );
        });
    }
}

GridSuggestion.propTypes = {
    userId: PropTypes.string,
    viewer: PropTypes.object,
    data: PropTypes.array,
    copy: PropTypes.object.isRequired,
    selectedItemIds: PropTypes.array,
    darkGrid: PropTypes.bool,
    onFavorited: PropTypes.func,
    onAddItemSuccess: PropTypes.func,
    currency: PropTypes.string,
};

GridSuggestion.defaultProps = {
    data: [],
    darkGrid: true,
    domId: 'suggestion-grid',
    gridType: 'you may also like',
};

module.exports = {
    GridSuggestion,
    GridSuggestionRelayContainer: Relay.createContainer(GridSuggestion, {
        initialVariables: {
            first: 0,
            userId: null,
            userIds: [],
            selectedItemIds: [],
            loadPortfolioData: false,
            shouldFillInFolder: false,
        },
        prepareVariables: params => ({
            ...params,
            first: params.selectedItemIds.length,
        }),
        fragments: {
            viewer: params => Relay.QL`
                fragment on Viewer {
                    ${GridItemRelayContainer.getFragment('viewer', params)}
                    items(itemIds: $selectedItemIds, first: $first) {
                        edges {
                            node {
                                serviceId
                                ${GridItemRelayContainer.getFragment('item', params)}
                            }
                        }
                    }
                }
            `,
        },
    }),
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Grid/GridSuggestion.jsx